module.exports = "<app-dashboard-gh *ngIf=\"country === 'GHA' \"></app-dashboard-gh>\n<app-dashaboard *ngIf=\"country !== 'GHA' \"></app-dashaboard>"